export default __webpack_public_path__ + "static/media/android-app.4d691af8.png";